import { BRAND } from "@/lib/brand";
import { localeUrl, type SupportedLanguage } from "@/lib/site";
import type { FaqItem } from "@/sections/Faq";

/** 09-landing-page.md §5.2 `EducationalOrganization` JSON-LD. */
export function buildOrganizationJsonLd(
  lang: SupportedLanguage,
): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: BRAND.nameEn,
    alternateName: BRAND.nameAr,
    url: localeUrl(lang),
    logo: BRAND.logoUrl,
    image: BRAND.ogImage,
    sameAs: [BRAND.facebookUrl, BRAND.instagramUrl],
    address: {
      "@type": "PostalAddress",
      streetAddress: lang === "ar" ? BRAND.addressAr : BRAND.addressEn,
      addressLocality: "Cairo",
      addressCountry: "EG",
    },
    telephone: BRAND.phoneE164,
    contactPoint: {
      "@type": "ContactPoint",
      telephone: BRAND.phoneE164,
      contactType: "admissions",
      areaServed: "EG",
      availableLanguage: ["ar", "en"],
    },
  };
}

/** 09-landing-page.md §5.2 "Add a second FAQPage JSON-LD block if the #faq section ships". */
export function buildFaqJsonLd(items: FaqItem[]): Record<string, unknown> {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer,
      },
    })),
  };
}
